export class BrowserUtils
{
	public static scrollToTop()
	{
		window.scrollTo(0, 0);
	}
}